'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OnShelfButton = require('./components/OnShelfButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OnShelfButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-on-shelf-button/lib/index.js
// module id = 1497
// module chunks = 1